const { connect } = require('react-redux');
const CmWalletBuy = require('./cmWalletBuy');

// @ actions
const cmWalletBuyActions = require('../../../actions/cmWalletBuy');
const cmLegalDocuments = require('../../../actions/cmLegalDocuments');

module.exports.CmWalletBuy = connect(
    state => ({
        immCmWalletBuy: state.cm,
        immCmLegalDocuments: state.cmLegalDocuments,
        immAccounts: state.accounts,
        flagBasedFeatures: state.flagBasedFeatures,
    }),
    {
        changeDisclaimerCheck: cmWalletBuyActions.changeDisclaimerCheck,
        validateStep: cmWalletBuyActions.validateStep,
        setVisibleStep: cmWalletBuyActions.setVisibleStep,
        setWillCancel: cmWalletBuyActions.setWillCancel,
        setWillLeave: cmWalletBuyActions.setWillLeave,
        onAccountChange: cmWalletBuyActions.changeSelectedAccount,
        setAccount: cmWalletBuyActions.setAccount,
        disableNextButton: cmWalletBuyActions.disableNextButton,
        runTransferLiquidityOrchestrator:
            cmWalletBuyActions.orchestratorOrderConfirmation,
        enableNextButton: cmWalletBuyActions.enableNextButton,
        onSetAmount: cmWalletBuyActions.setAmount,
        setAccountChanged: cmWalletBuyActions.setAccountChanged,
        onSetInitialAmount: cmWalletBuyActions.setInitialAmount,
        setIntervenerName: cmWalletBuyActions.setIntervenerName,
        setIntervenerType: cmWalletBuyActions.setIntervenerType,
        addIntervener: cmWalletBuyActions.addIntervener,
        removeIntervener: cmWalletBuyActions.removeIntervener,
        restoreDefaultInterveners: cmWalletBuyActions.restoreDefaultInterveners,
        portfolioOrderConfirmation:
            cmWalletBuyActions.portfolioOrderConfirmation,
        fetchLegalDocuments: cmLegalDocuments.fetchLegalDocuments,
        onConfirmLeaveTransferMoneyToOtherPage:
            cmWalletBuyActions.confirmLeaveTransferMoneyToOtherPage,
        resetConsents: cmWalletBuyActions.resetConsents,
        activatePreLeaveModal: cmWalletBuyActions.activatePreLeaveModal,
        deactivatePreLeaveModal: cmWalletBuyActions.deactivatePreLeaveModal,
        resetStep: cmWalletBuyActions.resetStep,
        onFilterAccountChange: cmWalletBuyActions.filterAccountChange,
        getPortfolioList: cmWalletBuyActions.getPortfolioList,
        onWalletChange: cmWalletBuyActions.onWalletChange,
        resetOriginFund: cmWalletBuyActions.resetOriginFund,
        saveOriginFundMatchedInPortfolio:
            cmWalletBuyActions.saveOriginFundMatchedInPortfolio,
    },
)(CmWalletBuy);
